import { useNavigate } from "react-router-dom";
import { ServiceLevelCard } from "./ServiceLevelCard";
import { templates } from "@/utils/capsulaTemplates";

interface ServiceLevelSelectorProps {
  capsulaTheme: string;
  recommendSupport?: boolean;
}

export function ServiceLevelSelector({
  capsulaTheme,
  recommendSupport = true,
}: ServiceLevelSelectorProps) {
  const navigate = useNavigate();

  const handleDIYClick = () => {
    // Scroll to articles
    const articlesSection = document.getElementById("discovery-articles");
    if (articlesSection) {
      articlesSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleSupportClick = () => {
    navigate(`/contacto?tipo=support&capsula=${capsulaTheme}`);
  };

  return (
    <div className="py-24 md:py-32 px-4">
      <div className="max-w-7xl mx-auto space-y-16">
        {/* Header */}
        <div className="text-center space-y-8">
          <p className="text-xl md:text-2xl font-light text-muted-foreground leading-relaxed">
            {templates.cta.question}
          </p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-light text-foreground tracking-tight leading-tight">
            {templates.cta.mainHeading}
          </h2>
        </div>

        {/* Service Level Cards */}
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 max-w-6xl mx-auto">
          {/* DIY Option */}
          <ServiceLevelCard
            title="Lo pruebo yo mismo"
            benefits={[
              "Lee las guías y hazte una idea",
              "Sin presión, a tu ritmo",
              "Todo gratis, sin letra pequeña",
            ]}
            cta="Ver guías"
            onClick={handleDIYClick}
            recommended={false}
          />

          {/* Support Option */}
          <ServiceLevelCard
            title="Con vuestro apoyo"
            benefits={[
              "Cuéntanos tu caso",
              "Te ayudamos a ver si te encaja",
              "Sin compromiso, charlamos",
            ]}
            cta="Contactar →"
            onClick={handleSupportClick}
            recommended={recommendSupport}
          />
        </div>

        {/* Subtle reassurance text */}
        <p className="text-center text-base md:text-lg text-muted-foreground max-w-3xl mx-auto mt-20 font-light leading-relaxed">
          No hay compromiso ni letras pequeñas. Solo queremos ayudarte a entender 
          si esta herramienta tiene sentido para tu negocio. Respondemos en menos de 24h.
        </p>
      </div>
    </div>
  );
}
